export default __webpack_public_path__ + "static/DT_logo_no-ring-904161a2e7929734576d7c2a1604b1fb.svg";